<template>
    <svg viewBox="0 0 86 62" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M85.9209 6.83201C85.9137 3.27148 83.0729 0.360219 79.5993 0.3672L5.48738 0.506827C2.46681 0.513808 -0.0071762 3.05505 1.56403e-05 6.15481L0.0863142 55.2692C0.093506 58.8297 2.93428 61.741 6.40794 61.734L78.7362 61.5944C82.7421 61.5874 86.0072 58.2223 86 54.1103L85.9209 6.83201Z"
            fill="#0DA2E7"
        />
        <path
            d="M5.27686 0.498464C9.04346 6.49531 15.7341 14.3783 24.4484 22.1161C39.8821 35.6228 62.0856 48.9707 85.9096 50.5873V6.66803C85.9096 3.18599 82.964 0.360291 79.3343 0.3672L5.27686 0.498464Z"
            fill="#22BCFF"
        />
        <path
            d="M43.6632 52.625C55.1278 52.625 64.4218 43.3454 64.4218 31.8984C64.4218 20.4515 55.1278 11.1719 43.6632 11.1719C32.1985 11.1719 22.9045 20.4515 22.9045 31.8984C22.9045 43.3454 32.1985 52.625 43.6632 52.625Z"
            fill="white"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M32.4121 23.4592C32.4121 21.6862 33.3421 20.7687 35.1646 20.7687L52.1521 20.748C53.9746 20.748 54.9046 21.6587 54.9121 23.4316L54.9346 40.0088C54.9346 41.7887 54.0046 42.6993 52.1821 42.6993L35.1946 42.72C33.3721 42.72 32.4421 41.8094 32.4346 40.0364L32.4121 23.4592Z"
            fill="#0DA2E7"
        />
        <path
            d="M55.0349 39.9691L55.0123 23.3672C55.0123 21.5917 54.0723 20.6797 52.245 20.6797L35.2122 20.7004C33.3849 20.7004 32.4524 21.6193 32.4524 23.3948L32.4599 29.7371C38.9346 34.3522 46.1688 38.7048 53.937 42.2835C54.6664 41.8621 55.0349 41.0883 55.0349 39.9691Z"
            fill="#22BCFF"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M45.913 23.7051V26.4396H47.4415V27.8284C47.4415 29.7682 46.5949 31.906 44.4128 32.3071V37.3495C44.4154 37.964 44.3948 38.8145 43.803 39.4061C43.3089 39.8987 42.5395 40.1272 41.3815 40.1272C40.0949 40.1272 39.2817 39.8327 38.8083 39.2005C38.3734 38.619 38.3734 37.9056 38.3734 37.3495V34.6303C38.3734 33.6985 38.3734 33.4141 36.8294 33.4141H32.3159V31.9111H36.8526C39.6368 31.9111 39.871 33.3151 39.871 34.6278V37.3495C39.871 37.3984 39.8706 37.4462 39.8702 37.4928C39.8675 37.8242 39.8653 38.0976 40.0074 38.289C40.1695 38.5073 40.6404 38.6267 41.3764 38.6267C42.3182 38.6267 42.6424 38.4438 42.7505 38.3347C42.8997 38.1874 42.8997 37.8294 42.8997 37.3495V32.3071C40.715 31.906 39.871 29.758 39.871 27.8284V26.4396H41.3867V23.7051H42.8946V26.4396H44.4051V23.7051H45.913Z"
            fill="white"
        />
    </svg>
</template>
